module.exports = function(object, callback) {
  for (var key in object) {
    callback(object[key], key);
  }
};
